import { SingleRowAction, MultiRowAction, SelectAllAction, CRMSelectAllOptions } from '@galaxy/crm/static';
import { Row } from '@vendasta/galaxy/table';
import { ContactProvider } from '@galaxy/email-ui/shared';
import { EmailWorkflowService, ProviderConnectionOption } from './email-workflow.service';
import { EmailProvider } from './send-email/constants';

export function EmailSingleRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
  connections: ProviderConnectionOption[] = [],
  contactProvider?: ContactProvider,
): SingleRowAction {
  return {
    label: label,
    callback: (row) => {
      service.openEmailComposerFromRows(namespace, userId, [row], provider, connections, contactProvider);
    },
  };
}

export function EmailMultiRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
  connections: ProviderConnectionOption[] = [],
  contactProvider?: ContactProvider,
): MultiRowAction {
  return {
    label: label,
    callback: (rows) => {
      service.openEmailComposerFromRows(namespace, userId, rows, provider, connections, contactProvider);
    },
  };
}

export function EmailSelectAllRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
  connections: ProviderConnectionOption[] = [],
  contactProvider?: ContactProvider,
): SelectAllAction {
  return {
    label: label,
    callback: (rows: Row[], _options?: CRMSelectAllOptions) => {
      service.openEmailComposerFromRows(namespace, userId, rows, provider, connections, contactProvider);
    },
  };
}
